import script from "./PaperoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperoutView.vue?vue&type=script&setup=true&lang=js"

import "./PaperoutView.vue?vue&type=style&index=0&id=20b8cf91&lang=css"

const __exports__ = script;

export default __exports__